import React from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import ModalSimple from '../../global/modal-simple';
import InfoIcon from './shared/info-icon';
import {Portal} from '../../util';

const GradYear: React.FC = observer(() => {
    const save = (e: React.ChangeEvent<HTMLInputElement>) => {
        s.ps.grad_year = e.target.value;
    };

    if (!s.ps.is_caf || !s.ui.show_cust || !s.ui.show_grad_year) {
        return (
            <div className="gray-box">
                <ModalSimple
                    id="modal-grad-year"
                    title={`Need a frame matching a different ${s.ui.doc_type.toLowerCase()} size?`}
                >
                    <div>
                        <div className="header-std">Why Do You Need My Graduation Year?</div>
                        <p>
                            Knowing your class year will ensure we custom-build your frame to the correct specifications. Over time, Institutions may change the dimensions of their certificates, so knowing the exact year you graduated will ensure you receive the correct frame size. Rest assured, the
                            class year you provide is for reference only and will not appear anywhere on your diploma frame.
                        </p>
                        <div className="header-std">Any questions?</div>
                        <p>
                            Reach out to our friendly customer service team at {Portal?.CustomerServiceEmail}, through our Live Chat service, or you can reach us M-F 8:30 am - 5 pm Eastern at {Portal?.CustomerServicePhone}.
                        </p>
                    </div>
                </ModalSimple>
                <div className="grad-year-container">
                    <span
                        className="header-std"
                        style={{minWidth: 141}}
                    >
                        Graduation Year:
                    </span>
                    <input
                        type="text"
                        className="form-control ib input-qty"
                        style={{maxWidth: 125, minWidth: 70}}
                        onChange={save}
                        maxLength={4}
                        max={3000}
                        min={-9999}
                        aria-label="Enter graduation year"
                    />
                    <div
                        className="info"
                        style={{minWidth: 110}}
                    >
                        <InfoIcon
                            id="modal-grad-year"
                            ariaLabel="Open information about the graduation year for this product"
                            styleBlack={true}
                        />
                        <span
                            className="hint"
                            style={{paddingLeft: 4, color: '#222'}}
                        >
                            (if available)
                        </span>
                    </div>
                </div>
            </div>
        );
    } else {
        return <div className="hide" />;
    }
});

export default GradYear;
